<template>
	<sub-dialog ref="dialog" type="confirm" :title="title" :width="width" :close-btn="false">
		<div class="sub-confirm flex">
			<i v-if="iconClass" class="sf" :class="[iconClass]"></i>
			<p v-html="text"></p>
		</div>
			
		<template slot="button">
			<sub-button width="72" height="34" size="m" @click="buttonHandle('resolve')">{{buttonName}}</sub-button>
			<sub-button v-if="cancelButton" width="72" height="34" size="m" color="black" hollow @click="buttonHandle('cancel')">取消</sub-button>
		</template>
	</sub-dialog>
</template>

<script>
	export default {
		name: 'confirm',

		data() {
			return {
				title: '消息提醒',
				width: 450,
				text: '',
				icon: 'ask',
				buttonName: '确定',
				cancelButton: true
			};
		},

		mounted() {
			this.$refs.dialog.open();
		},

		computed: {
			iconClass() {
				return {
					warn: 'sf-warn',
					ask: 'sf-help'
				}[this.icon];
			}
		},

		methods: {
			buttonHandle(state) {
				this[state] && this[state]();
				this.$refs.dialog.close();
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.sub-confirm {
		padding: 40px 36px;
		line-height: 22px;
		font-size: 14px;
		color: #333;
		word-break: break-all;
		
		.sf {
			margin-right: 14px;
			font-size: 30px;
			color: #EB0000;
		}
	}
</style>
